export default new class BreadcrumbScrollInitService {
    public init(): void {
        const breadcrumbNavigation = document.querySelector<HTMLUListElement>("#breadcrumbnav");

        if (breadcrumbNavigation === null) {
            return;
        }

        breadcrumbNavigation.scrollLeft += breadcrumbNavigation.scrollWidth;
    }
}();
